
import { locale } from './globals.js';

const arrowBtn = function (dir) {
  return `<button class="arrow ${dir} custom">
    <i class="fal fa-chevron-circle-${locale[dir]} icon"></i>
  </button>`
}

class BoxSlider {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.list = this.el.querySelector('[data-box-slider-list]');
    this.rtl = (locale.dir == 'rtl');
    if(this.list.children.length > 1) {
      this.initSlider();
    }
  }
  initSlider () {
    this.flkty = new Flickity(this.list, {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      rightToLeft: this.rtl,
      autoPlay: 4000
    });
    this.pager = document.createElement('div');
    this.pager.classList.add('box-slider-pager', 'pager-arrows');
    this.pager.innerHTML = arrowBtn('prev') + arrowBtn('next');
    this.el.insertBefore(this.pager, this.el.firstChild);
    requestAnimationFrame(() => {
      this.initPagerControls(); 
    });

  }
  initPagerControls() {
    this.pager.querySelector('.arrow.prev').addEventListener('click', () => {
      this.flkty.previous(true);
    })
    this.pager.querySelector('.arrow.next').addEventListener('click', () => {
      this.flkty.next(true);
    })
  }
}
export default function () {
  Array.from(document.querySelectorAll('[data-box-slider]')).forEach( (box) => {
    new BoxSlider(box);
  });
}
